import React, { useEffect, useState, useContext } from 'react';
import CheckField from '../../../../components/CheckField2/CheckField';
import Popover from "../../../../../formik/refactorOut/components/Popper/Popover";
import { popoverLocation } from "../../../../../config/Configuration";
import TextField from '../../../../components/TextField/TextField';

function DepartmentList({ deptlist, formik }) {
    const deptListFilled = deptlist.map((props, index) =>
        <> <CheckField id={props} checkboxType={'facility'} formik={formik} className={'advancedFacilityList'} formValue={props} checkItemLabel={props} />  &nbsp;</>
    );
    return (<> {deptListFilled} </>);
}


function FacilityRadioList({ formik, dbFormSpec, languageText }) {
    const [facilitySelect, setFacility] = useState("");
    const [languageTextlocal, setlanguageTextlocal] = useState(languageText);

    function FacilityChange(event) {
        setFacility(event.target.value);
        formik.setFieldValue('facilityList', [event.target.value], false);
    }

    function FacilityEntry({ props, formik }) {
        return (<div >
            <label className="radio-field2 subtitle2 false" htmlFor={"facilitySelect" + props.key}  >
                <input index={props.key} className="radio-button" type="radio" name="facilitySelect" checked={facilitySelect === props.value}
                    id={"facilitySelect" + props.key} value={props.value} onChange={FacilityChange} />&nbsp; {props.value}&nbsp;

                {props.address ?
                    <Popover placement={popoverLocation}>
                        <Popover.Target>
                            <i className="fa fa-info-circle fa_custom"></i>
                        </Popover.Target>
                        <Popover.Content>{props.address}</Popover.Content>
                    </Popover> : <></>}
            </label>
        </div>);
    }

    let DeptsDescription, ListProviders, FacilityLabel;

    if (languageTextlocal) {
        FacilityLabel = languageTextlocal.FacilityRadioList.Facility;
    } else {
        FacilityLabel = "Facilities:";
    }

    const facilityListFilled = dbFormSpec.release.facilities.map((props, index) => {
        if (languageTextlocal) {
            DeptsDescription = props.DeptsDescription ? props.DeptsDescription : languageTextlocal.FacilityRadioList.DeptsDescription;
            ListProviders = props.textBoxLabel ? props.textBoxLabel : languageTextlocal.FacilityRadioList.ListProviders;
        } else {
            DeptsDescription = props.DeptsDescription ? props.DeptsDescription : "Please select any departments you wish to release records from.";
            ListProviders = props.textBoxLabel ? props.textBoxLabel : 'List any providers, or physicians located at ';
        }

        let rowType = (props.type || "").toLowerCase();
        if (rowType === "hr") { return (<div>  <hr style={{ opacity: 0, marginBottom: 0 }} /><br /></div>); }
        else if (rowType === "text") {
            return (
                <div style={{ fontWeight: props.bold ? "bold" : null }}>
                    {props.value}</div>);
        }

        return (
            <div key={index + "_facilityListFilled"}>
                <div key={index + "_FacilityEntry"} ><FacilityEntry key={index + "_FacilityEntryInput"} props={props} formik={formik} /></div>
                <div key={index + "FacilityPhy_"} style={{ display: formik.values.facilityList.includes(props.value) ? 'flex' : 'none', marginTop: 20 }}>
                    {props.includeTextBox && <TextField key={index + "_FacilityEntryTextField"} fieldType={'facility'} formik={formik} fieldId={'CustomTextbox_FacilityPhy_' + props.key} cssField={'fname-field'} label={ListProviders + props.value} maxLength={500} />}
                </div>


                <div key={index + "FacilityDept_"} style={{ display: (formik.values.facilityList.includes(props.value) && props.Departments) ? 'flex' : 'none', marginTop: 20 }}>
                    <div>{DeptsDescription}</div>
                    <div>   {props.Departments && <DepartmentList deptlist={props.Departments} formik={formik} />}</div>
                </div>
            </div>
        )
    }
    );


    return (<div id="facilityRadioGroup" className="form-group" key="RadioFacilityListRendered" > {FacilityLabel}
        {facilityListFilled}
    </div>);

}

export default FacilityRadioList;